import React, { useState, useEffect } from 'react';
import P, { InferProps } from 'prop-types';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SxStyle } from '../../../types';

const styles: SxStyle = {
  switch: {
    paddingLeft: '10px',
    userSelect: 'none',
    height: '24px',
  },
};

function SwitchField({ field, setChange, isReadOnly }: InferProps<typeof SwitchField.propTypes>) {
  const [checked, setChecked] = useState<boolean>(field.value);

  useEffect(() => {
    setChecked(field.value);
  }, [field]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);

    if (setChange) {
      setChange(field.key, e.target.checked, field.validation, field.isTeamDataValue);
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          disabled={field.key === 'Not available' || !!isReadOnly}
          checked={checked}
          onChange={handleChange}
          name={field.id}
          color="primary"
          edge={'start'}
        />
      }
      label={field.title as string}
      sx={styles.switch}
    />
  );
}

SwitchField.propTypes = {
  field: P.shape({
    title: P.string,
    id: P.string.isRequired,
    type: P.string,
    validation: P.object,
    key: P.string,
    value: P.bool.isRequired,
    isTeamDataValue: P.bool,
  }).isRequired,
  setChange: P.func,
  isReadOnly: P.bool,
};

export default React.memo(SwitchField);
